import React from 'react';
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';
import SignUp from '../components/SignUp';
import SignIn from '../components/SignIn';
import logo from '../images/bookie-logo.svg';
import UserBooks from '../components/UserBooks';
import { useTranslation } from '../i18n';
import Footer from '../components/Footer';
import { Link } from 'react-router-dom';

const Login = ({
  user,
  userData,
  books,
  fetchBooks,
  fetchUserData,
  showNotification,
  updateCurrentlyReading,
  theme,
  handleThemeChange,
}) => {
  const { t } = useTranslation();

  return (
    <div className="container">
      {user ? (
        <UserBooks
          user={user}
          userData={userData}
          books={books}
          fetchBooks={fetchBooks}
          fetchUserData={fetchUserData}
          showNotification={showNotification}
          updateCurrentlyReading={updateCurrentlyReading}
        />
      ) : (
        [
          <div key="wrapper" className="logo-wrapper">
            <Link to="/" style={{ height: '65px' }}>
              <img src={logo} alt="Bookie logo" width={200} height={65} />
            </Link>
            <h1>{t.tagline}</h1>
          </div>,
          <Tabs key="tabs" className="emb-3">
            <TabList className="tabs">
              <Tab className="tab fs-l">{t.signin}</Tab>
              <Tab className="tab fs-l">{t.register}</Tab>
            </TabList>

            <TabPanel>
              <SignIn showNotification={showNotification} />
            </TabPanel>
            <TabPanel>
              <SignUp showNotification={showNotification} />
            </TabPanel>
          </Tabs>,
          <Footer
            key="footer"
            theme={theme}
            handleThemeChange={handleThemeChange}
          />,
        ]
      )}
    </div>
  );
};

export default Login;
